import "./Grid.scss";

import { GridColumnMenuItem as KGridColumnMenuItem } from "@progress/kendo-react-grid";

// TODO: fix this once they resolve import path
import type { GridColumnMenuItemProps as KGridColumnMenuItemProps } from "@progress/kendo-react-grid/dist/npm/columnMenu/GridColumnMenuItem";

export const GridColumnMenuItem = function render(props: KGridColumnMenuItemProps) {
  return <KGridColumnMenuItem {...props} />;
};

export interface GridColumnMenuItemProps extends KGridColumnMenuItemProps {}
